var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-back"},[_c('span',{staticClass:"header-back-btn",attrs:{"role":"button"},on:{"click":_vm.group1.historyBack}},[_c('FontawesomeIcon',{attrs:{"icon":['far','angle-left'],"size":"lg"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }